module.exports = __webpack_public_path__ + "b8e728d80a7c2d1e15663176747c65ff.pdf";